module.exports = __webpack_public_path__ + "static/media/play-player-capture.51e9bbf3.png";